import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../shared/shared.module';
import { ConnectTradeDeskAgencyRoutingModule } from './connect-trade-desk-agency-routing.module';
import { ConnectTradeDeskAgencyComponent } from './connect-trade-desk-agency.component';

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        SharedModule,
        ConnectTradeDeskAgencyRoutingModule
    ],
    declarations: [ConnectTradeDeskAgencyComponent],
    exports: [ConnectTradeDeskAgencyComponent],
    providers: []
})
export class ConnectTradeDeskAgencyModule {}
